import { useMemo } from "react";
import bondSecuritiesStore from "@/store/bondSecuritiesStore";
import { findBondSecurityByIsin } from "@/store/bondSecuritiesStoreACTIONS";
import tradeFromScratchStore, {
  IBondTicket,
  returnEmptyBondTicket,
} from "@/store/tradeFromScratchStore";
import {
  BOND_TICKET_REQUIRED_KEYS,
  returnMissingBondTicketEntries,
} from "../helper/bondTicketHelper";

// One bond ticket by id: the stored ticket, its updater and what derives from it.
// Shared by the Leg Creation shell and the field components.
export function useBondTicket(ticketId: string) {
  const storedTicket = tradeFromScratchStore(
    (state) => state.bondTicketsByTicketId[ticketId],
  );
  const updateTicket = tradeFromScratchStore((state) => state.updateBondTicket);
  // Subscribed so the ticket re-renders if the securities land after it mounts.
  bondSecuritiesStore((state) => state.bondSecurities);

  // Covers the render before the owner seeds the ticket. Memoised, as a fresh object
  // per render would loop forever.
  const emptyTicket = useMemo(() => returnEmptyBondTicket(), []);
  const ticket = storedTicket ?? emptyTicket;

  return {
    ticket,
    updateBondTicket: (changes: Partial<IBondTicket>) =>
      updateTicket(ticketId, changes),
    security: findBondSecurityByIsin(ticket.isin),
    missingEntries: returnMissingBondTicketEntries(ticket),
    requiredKeys: BOND_TICKET_REQUIRED_KEYS,
  };
}
